<div id="st-event-filter-filtersidebar" class="filter_sidebar" [class.mobile_filter]="innerWidth < 500">
  <p-sidebar position="right" [(visible)]="visible" (onHide)="closeFilters.emit()" [blockScroll]="true"
    [showCloseIcon]="false" appendTo="body" styleClass="event-filter-sidebar" [baseZIndex]="1200" [autoZIndex]="true">
    <ng-template pTemplate="content">
      <div id="st-event-filter-sidebar-container" class="sidebar-container">
        <svg class="icon-sprite" aria-hidden="true" focusable="false">
          <defs>
            <symbol id="icon-close" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                d="M18 6 6 18M6 6l12 12" />
            </symbol>
            <symbol id="icon-filter" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"
                d="M3 5h18l-7 8v6l-4 2v-8z" />
            </symbol>
            <symbol id="icon-arrow-right" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                d="M4.5 12h15M13 6l6 6-6 6" />
            </symbol>
          </defs>
        </svg>

        <header id="st-event-filter-sidebar-header"
          class="sidebar-header d-flex align-items-center justify-content-between px-3 py-2">
          <div id="st-event-filter-header-content" class="header-content d-flex align-items-center gap-2">
            <span class="header-icon" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24">
                <use href="#icon-filter" />
              </svg>
            </span>
            <h2 class="fs-16 fw-bold m-0">{{ 'filters' | translate }}</h2>
            <span class="header-count-badge fs-10 fw-semibold" *ngIf="getTotalSelectedFilterCount() > 0">{{
              getTotalSelectedFilterCount() }}</span>
          </div>
          <div class="d-flex align-items-center gap-2 flex-grow-1 justify-content-end w-100">
            <!-- Always mounts so header height stays stable when search is N/A -->
            <div class="event-filter-search-slot" [attr.aria-hidden]="activeSearchableRole ? null : 'true'">
              <div class="event-filter-search" *ngIf="activeSearchableRole as role">
                <img src="../../../../assets/ranking-rating_assets/search_icon_p3.svg" alt=""
                  class="event-filter-search-icon" aria-hidden="true" />
                <input type="text" [placeholder]="'search_placeholder' | translate"
                  class="event-filter-search-input fs-13 fw-semibold"
                  [ngModel]="roleSearchValues[role.parent_role_name] || ''"
                  (ngModelChange)="onRoleSearchInput(role, $event)" />
                <button type="button" class="event-filter-search-clear"
                  *ngIf="(roleSearchValues[role.parent_role_name] || '').length > 0" (click)="clearRoleSearch(role)"
                  aria-label="Clear">
                  <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true">
                    <use href="#icon-close" />
                  </svg>
                </button>
              </div>
            </div>
            <button class="close-btn" (click)="closeFilters.emit()" [attr.aria-label]="'close' | translate">
              <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
                <use href="#icon-close" />
              </svg>
            </button>
          </div>
        </header>

        <div id="st-event-filter-sidebar-content" class="sidebar-content">
          <nav id="st-event-filter-left-pane" class="left-pane d-flex flex-column p-2 gap-1" role="tablist"
            aria-orientation="vertical" (keydown)="onTablistKeydown($event)">
            <button *ngIf="filterConfig.category" type="button" role="tab" id="st-ef-tab-category"
              aria-controls="st-event-filter-block-category" [attr.aria-selected]="activeTab === 'category'"
              [attr.tabindex]="activeTab === 'category' ? 0 : -1" class="nav-item"
              [class.active]="activeTab === 'category'" (click)="setActiveTab('category')">
              <span class="nav-label fs-12 fw-semibold">{{ (event_type === 'T' ? 'category' : 'division') | translate
                }}</span>
              <span *ngIf="getSelectedCategoryCount() > 0" class="nav-badge fs-10 fw-semibold">{{
                getSelectedCategoryCount() }}</span>
            </button>
            <button *ngIf="filterConfig.stage" type="button" role="tab" id="st-ef-tab-stage"
              aria-controls="st-event-filter-block-stage" [attr.aria-selected]="activeTab === 'stage'"
              [attr.tabindex]="activeTab === 'stage' ? 0 : -1" class="nav-item" [class.active]="activeTab === 'stage'"
              (click)="setActiveTab('stage')">
              <span class="nav-label fs-12 fw-semibold">{{ 'stage' | translate }}</span>
              <span *ngIf="getSelectedStageCount() > 0" class="nav-badge fs-10 fw-semibold">{{ getSelectedStageCount()
                }}</span>
            </button>
            <button *ngIf="filterConfig.venue" type="button" role="tab" id="st-ef-tab-venue"
              aria-controls="st-event-filter-block-venue" [attr.aria-selected]="activeTab === 'venue'"
              [attr.tabindex]="activeTab === 'venue' ? 0 : -1" class="nav-item" [class.active]="activeTab === 'venue'"
              (click)="setActiveTab('venue')">
              <span class="nav-label fs-12 fw-semibold">{{ 'venue' | translate }}</span>
              <span *ngIf="getSelectedVenueCount() > 0" class="nav-badge fs-10 fw-semibold">{{ getSelectedVenueCount()
                }}</span>
            </button>
            <button *ngIf="filterConfig.table" type="button" role="tab" id="st-ef-tab-table"
              aria-controls="st-event-filter-block-table" [attr.aria-selected]="activeTab === 'table'"
              [attr.tabindex]="activeTab === 'table' ? 0 : -1" class="nav-item" [class.active]="activeTab === 'table'"
              (click)="setActiveTab('table')">
              <span class="nav-label fs-12 fw-semibold">{{ 'table' | translate | titlecase }}</span>
              <span *ngIf="getSelectedTableCount() > 0" class="nav-badge fs-10 fw-semibold">{{ getSelectedTableCount()
                }}</span>
            </button>
            <button *ngIf="filterConfig.status" type="button" role="tab" id="st-ef-tab-status"
              aria-controls="st-event-filter-block-status" [attr.aria-selected]="activeTab === 'status'"
              [attr.tabindex]="activeTab === 'status' ? 0 : -1" class="nav-item" [class.active]="activeTab === 'status'"
              (click)="setActiveTab('status')">
              <span class="nav-label fs-12 fw-semibold">{{ 'match_status' | translate }}</span>
              <span *ngIf="getSelectedStatusCount() > 0" class="nav-badge fs-10 fw-semibold">{{ getSelectedStatusCount()
                }}</span>
            </button>
            <button *ngIf="filterConfig.time" type="button" role="tab" id="st-ef-tab-time"
              aria-controls="st-event-filter-block-time" [attr.aria-selected]="activeTab === 'time'"
              [attr.tabindex]="activeTab === 'time' ? 0 : -1" class="nav-item" [class.active]="activeTab === 'time'"
              (click)="setActiveTab('time')">
              <span class="nav-label fs-12 fw-semibold">{{ 'match_time' | translate }}</span>
              <span *ngIf="getSelectedTimeCount() > 0" class="nav-badge fs-10 fw-semibold">{{ getSelectedTimeCount()
                }}</span>
            </button>

            <ng-container *ngIf="filterConfig.roles && parent_role_list.length > 0">
              <button *ngFor="let role of parent_role_list; trackBy: trackById" type="button" role="tab"
                [attr.id]="'st-ef-tab-role-' + role.parent_role_name"
                [attr.aria-controls]="'st-event-filter-block-role-' + role.parent_role_name"
                [attr.aria-selected]="activeTab === 'role_' + role.parent_role_name"
                [attr.tabindex]="activeTab === 'role_' + role.parent_role_name ? 0 : -1" class="nav-item"
                [class.active]="activeTab === 'role_' + role.parent_role_name" (click)="selectRoleTab(role)">
                <span class="nav-label fs-12 fw-semibold">{{ role.parent_role_name | translate }}</span>
                <span *ngIf="getSelectedRoleCount(role) > 0" class="nav-badge fs-10 fw-semibold">{{
                  getSelectedRoleCount(role) }}</span>
              </button>
            </ng-container>

            <ng-container *ngIf="is_video_filter">
              <button type="button" role="tab" id="st-ef-tab-video-events"
                aria-controls="st-event-filter-block-video-events" [attr.aria-selected]="activeTab === 'video_events'"
                [attr.tabindex]="activeTab === 'video_events' ? 0 : -1" class="nav-item"
                [class.active]="activeTab === 'video_events'" (click)="setActiveTab('video_events')">
                <span class="nav-label fs-12 fw-semibold">{{ 'event_name_and_category' | translate }}</span>
                <span *ngIf="getSelectedVideoEventsCount() > 0" class="nav-badge fs-10 fw-semibold">{{
                  getSelectedVideoEventsCount() }}</span>
              </button>
              <button type="button" role="tab" id="st-ef-tab-video-status"
                aria-controls="st-event-filter-block-video-status" [attr.aria-selected]="activeTab === 'video_status'"
                [attr.tabindex]="activeTab === 'video_status' ? 0 : -1" class="nav-item"
                [class.active]="activeTab === 'video_status'" (click)="setActiveTab('video_status')">
                <span class="nav-label fs-12 fw-semibold">{{ 'match_status' | translate }}</span>
                <span *ngIf="getSelectedVideoStatusCount() > 0" class="nav-badge fs-10 fw-semibold">{{
                  getSelectedVideoStatusCount() }}</span>
              </button>
              <button type="button" role="tab" id="st-ef-tab-video-sports"
                aria-controls="st-event-filter-block-video-sports" [attr.aria-selected]="activeTab === 'video_sports'"
                [attr.tabindex]="activeTab === 'video_sports' ? 0 : -1" class="nav-item"
                [class.active]="activeTab === 'video_sports'" (click)="setActiveTab('video_sports')">
                <span class="nav-label fs-12 fw-semibold">{{ 'sports' | translate }}</span>
              </button>
            </ng-container>
          </nav>

          <div id="st-event-filter-right-pane" class="right-pane d-flex flex-column p-3 gap-2">
            <!-- Category / Division -->
            <div id="st-event-filter-block-category" role="tabpanel" aria-labelledby="st-ef-tab-category"
              *ngIf="activeTab === 'category'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ (event_type === 'T' ?
                  'select_categories_you_would_like_to_view' : 'select_divisions_you_would_like_to_view') | translate }}
                </p>
              </div>
              <div class="club-options d-flex flex-column gap-1"
                *ngIf="category_list.length > 0; else noCategoryResults">
                <label *ngFor="let item of category_list; trackBy: trackById" class="club-option fs-12 fw-semibold"
                  [class.active]="isCategorySelected(item)">
                  <input type="checkbox" [checked]="isCategorySelected(item)" (change)="toggleCategory(item)" />
                  <span class="option-label">{{ item | categoryDisplayLabel }}</span>
                </label>
              </div>
              <ng-template #noCategoryResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Stage -->
            <div id="st-event-filter-block-stage" role="tabpanel" aria-labelledby="st-ef-tab-stage"
              *ngIf="activeTab === 'stage'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'select_stages_you_would_like_to_view' | translate }}
                </p>
              </div>
              <div class="club-options d-flex flex-column gap-1" *ngIf="stages_list.length > 0; else noStageResults">
                <label *ngFor="let item of stages_list; trackBy: trackById" class="club-option fs-12 fw-semibold"
                  [class.active]="isStageSelected(item)">
                  <input type="checkbox" [checked]="isStageSelected(item)" (change)="toggleStage(item)" />
                  <span class="option-label">{{ item.name
                    }}<span class="stage-option-category fs-11"
                      *ngIf="item?.event_category?.category?.category_description"> ·
                      {{ item.event_category.category.category_description }}</span></span>
                </label>
              </div>
              <ng-template #noStageResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Venue -->
            <div id="st-event-filter-block-venue" role="tabpanel" aria-labelledby="st-ef-tab-venue"
              *ngIf="activeTab === 'venue'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'select_venues_you_would_like_to_view' | translate }}
                </p>
              </div>
              <div class="club-options d-flex flex-column gap-1" *ngIf="venueDetails.length > 0; else noVenueResults">
                <label *ngFor="let item of venueDetails; trackBy: trackById" class="club-option fs-12 fw-semibold"
                  [class.active]="isVenueSelected(item)">
                  <input type="checkbox" [checked]="isVenueSelected(item)" (change)="toggleVenue(item)" />
                  <span class="option-label">{{ item.venue.name }}</span>
                </label>
              </div>
              <ng-template #noVenueResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Table -->
            <div id="st-event-filter-block-table" role="tabpanel" aria-labelledby="st-ef-tab-table"
              *ngIf="activeTab === 'table'" class="h-100">
              <div class="panel-header d-flex align-items-center justify-content-between gap-2">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'select_tables_you_would_like_to_view' | translate }}
                </p>
                <button type="button" class="panel-clear-all fs-12 fw-semibold" *ngIf="getSelectedTableCount() > 0"
                  (click)="clearTableSelections()">
                  {{ 'clear_all' | translate }}
                </button>
              </div>
              <div class="chip-grid" *ngIf="total_tables.length > 0; else noTableResults">
                <label *ngFor="let item of total_tables; trackBy: trackById" class="chip fs-12 fw-semibold"
                  [class.active]="isTableSelected(item)">
                  <input type="checkbox" [checked]="isTableSelected(item)" (change)="toggleTable(item)"
                    class="chip-input" />
                  <span>{{ item.table_number }}</span>
                </label>
              </div>
              <ng-template #noTableResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Match status -->
            <div id="st-event-filter-block-status" role="tabpanel" aria-labelledby="st-ef-tab-status"
              *ngIf="activeTab === 'status'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'filter_matches_status_wise' | translate }}</p>
              </div>
              <div class="club-options d-flex flex-column gap-1"
                *ngIf="match_status_list.length > 0; else noStatusResults">
                <label *ngFor="let item of match_status_list; trackBy: trackById" class="club-option fs-12 fw-semibold"
                  [class.active]="isStatusSelected(item)">
                  <input type="checkbox" [checked]="isStatusSelected(item)" (change)="toggleStatus(item)" />
                  <span class="option-label">{{ (item.label || item.status) | translate }}</span>
                </label>
              </div>
              <ng-template #noStatusResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Match time -->
            <div id="st-event-filter-block-time" role="tabpanel" aria-labelledby="st-ef-tab-time"
              *ngIf="activeTab === 'time'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'view_matches_only_from_a_specific_time_slots' |
                  translate }}</p>
              </div>
              <div class="d-flex align-items-center gap-3 flex-wrap">
                <div id="st-event-filter-start-time">
                  <p class="time-field-label fs-11 fw-semibold mb-1">{{ 'start_time' | translate }}</p>
                  <p-calendar class="calendar-input" inputId="st-event-filter-start-time" [(ngModel)]="start_time"
                    [showTime]="true" [hourFormat]="'24'" appendTo="body" [readonlyInput]="true"
                    panelStyleClass="accommodation-calendar-panel common-calendar-panel-mobile"
                    (onSelect)="filterSelected('start', $event)" />
                </div>
                <div id="st-event-filter-end-time">
                  <p class="time-field-label fs-11 fw-semibold mb-1">{{ 'end_time' | translate }}</p>
                  <p-calendar class="calendar-input" inputId="st-event-filter-end-time" [(ngModel)]="end_time"
                    [showTime]="true" appendTo="body" [hourFormat]="'24'" [readonlyInput]="true"
                    panelStyleClass="accommodation-calendar-panel common-calendar-panel-mobile"
                    (onSelect)="filterSelected('end', $event)" />
                </div>
              </div>
            </div>

            <!-- Roles (dynamic, one per parent_role_list entry) -->
            <ng-container *ngFor="let role of parent_role_list; trackBy: trackById">
              <div [id]="'st-event-filter-block-role-' + role.parent_role_name" role="tabpanel"
                [attr.aria-labelledby]="'st-ef-tab-role-' + role.parent_role_name"
                *ngIf="activeTab === 'role_' + role.parent_role_name">
                <div class="panel-header d-flex align-items-center justify-content-between gap-2">
                  <p class="panel-subtitle fs-11 fw-semibold m-0">
                    {{ 'select_the_role_you_want_to_view_matches_of' | translate:{ role: (role.parent_role_name |
                    translate) } }}
                  </p>
                  <button type="button" class="panel-clear-all fs-12 fw-semibold" *ngIf="getSelectedRoleCount(role) > 0"
                    (click)="clearRoleSelections(role)">
                    {{ 'clear_all' | translate }}
                  </button>
                </div>

                <!-- YOB: year picker + removable chip list -->
                <ng-container *ngIf="role.parent_role_name === 'YOB'; else roleList">
                  <mat-form-field appearance="outline" class="w-100 year-picker-field">
                    <input matInput [matDatepicker]="yobPicker" [placeholder]="'select' | translate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="yobPicker"></mat-datepicker-toggle>
                    <mat-datepicker #yobPicker startView="multi-year"
                      (yearSelected)="onYearSelected($event, yobPicker, role)"></mat-datepicker>
                  </mat-form-field>
                  <div class="d-flex gap-2 flex-wrap"
                    *ngIf="(selectedItemsMap[role.parent_role_name] || []).length > 0">
                    <div [id]="'st-event-filter-selecteditems-yob-' + j"
                      *ngFor="let selected of selectedItemsMap[role.parent_role_name]; let j = index; trackBy: trackById"
                      class="selected_items">
                      <div class="d-flex gap-2 align-items-center">
                        <p>{{ selected.parent_role_linked_field_value }}</p>
                        <button type="button" class="chip-remove"
                          (click)="roleRemoved(role.parent_role_name, j, selected.parent_user_role_id)"
                          [attr.aria-label]="('remove' | translate) + ' ' + selected.parent_role_linked_field_value">
                          <svg width="8" height="8" viewBox="0 0 24 24" aria-hidden="true">
                            <use href="#icon-close" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Other roles: searchable, paginated checkbox list -->
                <ng-template #roleList>

                  <div class="club-options d-flex flex-column gap-1" (scroll)="onRoleListScroll(role, $event)"
                    *ngIf="(role.parent_user_roles?.length ?? 0) > 0 || parentRoleLoading[role.parent_role_name]; else noRoleResults">
                    <label *ngFor="let item of filteredParentUserRoles(role); trackBy: trackById"
                      class="club-option fs-12 fw-semibold"
                      [class.active]="isRoleItemSelected(item, role.parent_role_name)">
                      <input type="checkbox" [checked]="isRoleItemSelected(item, role.parent_role_name)"
                        (change)="toggleRoleItem(item, role)" />
                      <span class="option-label">{{ item.parent_role_linked_field_value }}</span>
                    </label>
                    <div class="filter-empty-state filter-empty-state--inline py-2"
                      *ngIf="!parentRoleLoading[role.parent_role_name] && hasRoleSearchTerm(role) && filteredParentUserRoles(role).length === 0">
                      <stupa-empty-state purpose="no-results" />
                    </div>
                    <div class="d-flex align-items-center justify-content-center p-3"
                      *ngIf="parentRoleLoading[role.parent_role_name]">
                      <stupa-skeleton-loader [rows]="3" [columns]="1" />
                    </div>
                  </div>
                  <ng-template #noRoleResults>
                    <ng-container *ngIf="!parentRoleLoading[role.parent_role_name]; else roleLoading">
                      <div class="filter-empty-state mt-2">
                        <stupa-empty-state purpose="no-records"
                          [title]="'no_records_found_for_name' | translate:{name: role.parent_role_name}" />
                      </div>
                    </ng-container>
                    <ng-template #roleLoading>
                      <div class="d-flex align-items-center justify-content-center p-3">
                        <stupa-skeleton-loader [rows]="3" [columns]="1" />
                      </div>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </div>
            </ng-container>

            <!-- Video: events + nested categories -->
            <div id="st-event-filter-block-video-events" role="tabpanel" aria-labelledby="st-ef-tab-video-events"
              *ngIf="activeTab === 'video_events'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'select_event_names_and_categories_to_view' |
                  translate }}</p>
              </div>
              <div class="club-options d-flex flex-column gap-1"
                *ngIf="events_list.length > 0; else noVideoEventResults">
                <div [id]="'st-event-filter-video-event-' + item.id"
                  *ngFor="let item of events_list; trackBy: trackById; let i = index" class="d-flex flex-column">
                  <label class="club-option fs-12 fw-semibold" [class.active]="item.selected">
                    <input type="checkbox" [(ngModel)]="item.selected" (change)="onEventSelection(item, i)" />
                    <span class="option-label">{{ item.name }}</span>
                  </label>
                  <div class="d-flex flex-column gap-1 ms-4 mt-1"
                    *ngIf="item.selected && (item.categories?.length ?? 0) > 0">
                    <label *ngFor="let cat of item.categories; trackBy: trackById" class="club-option fs-12 fw-semibold"
                      [class.active]="cat.selected">
                      <input type="checkbox" [(ngModel)]="cat.selected" (change)="onCategorySelection(cat)" />
                      <span class="option-label">{{ cat.category_description }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <ng-template #noVideoEventResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-tournaments" [title]="'no_events_found' | translate" />
                </div>
              </ng-template>
            </div>

            <!-- Video: match status -->
            <div id="st-event-filter-block-video-status" role="tabpanel" aria-labelledby="st-ef-tab-video-status"
              *ngIf="activeTab === 'video_status'">
              <div class="panel-header">
                <p class="panel-subtitle fs-11 fw-semibold m-0">{{ 'select_match_status_you_would_like_to_view' |
                  translate }}</p>
              </div>
              <div class="club-options d-flex flex-column gap-1"
                *ngIf="stream_status.length > 0; else noVideoStatusResults">
                <label *ngFor="let item of stream_status; trackBy: trackById" class="club-option fs-12 fw-semibold"
                  [class.active]="isVideoStatusSelected(item)">
                  <input type="checkbox" [checked]="isVideoStatusSelected(item)" (change)="toggleVideoStatus(item)" />
                  <span class="option-label">{{ item.label }}</span>
                </label>
              </div>
              <ng-template #noVideoStatusResults>
                <div class="filter-empty-state h-100">
                  <stupa-empty-state purpose="no-records" />
                </div>
              </ng-template>
            </div>

            <!-- Video: sports (coming soon, locked) -->
            <div id="st-event-filter-block-video-sports" role="tabpanel" aria-labelledby="st-ef-tab-video-sports"
              *ngIf="activeTab === 'video_sports'">
              <div class="coming-soon-state d-flex flex-column align-items-center justify-content-center gap-2">
                <span class="coming-soon-badge fs-12 fw-semibold">{{ 'coming_soon' | translate }}</span>
              </div>
            </div>
          </div>
        </div>

        <div id="st-event-filter-sidebar-footer"
          class="sidebar-footer d-flex align-items-center justify-content-end gap-2 py-2 px-3">
          <button class="clear-btn fs-12 fw-semibold" (click)="clearFilters()">
            {{ 'clear_filters' | translate }}
            <span class="footer-count-badge fs-10 fw-semibold" *ngIf="getTotalSelectedFilterCount() > 0">{{
              getTotalSelectedFilterCount() }}</span>
          </button>
          <button class="apply-btn fs-13 fw-semibold" (click)="applyFilters()">
            {{ 'apply' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </p-sidebar>
</div>